<!-- =========================================================================================
    File Name: KnowledgeBase.vue
    Description: Knowledge Base Page

========================================================================================== -->


<template>
  <div id="knowledge-base-page">
    <!-- JUMBOTRON -->
    <div class="main-border rounded-lg mb-8">
      <div class="rounded-lg w-full"
         style="background-image: url(https://connect-cdn.intellectualpoint.com/assets/images/backgrounds/global-banner.png);
        background-size: cover;"
        >
      <div class="knowledge-base-jumbotron-content lg:p-12 sm:p-10 p-8 rounded-lg"
           style="height: 100%;">
        <h5 class="font-light text-white ml-1">Lab Admin</h5>
        <h1 class="mb-1 text-white font-bold" style="font-size: 2.9rem">Select a Component to Configure</h1>
      </div>
    </div>
    </div>


    <!--- COURSE ACTION BAR START --->
    <div class="vx-row mb-6 match-height">
      <div class="vx-col grid grid-cols-3 gap-8 w-full">
        <vx-card class="p-6 cursor-pointer flex items-center justify-center"
                 :style="`background-image: linear-gradient(118deg, rgba(var(--vs-success), 0.4), rgba(var(--vs-success), .2)), url(${cardBgImgURL})`"
                 @click="$router.push('/a/labs/properties/list')">
          <div class="flex items-center justify-center">
            <feather-icon icon="PackageIcon" svgClasses="h-16 w-16"/>
          </div>
          <div class="flex items-center justify-center">
            <h1 class="text-center mt-4">Lab<br>Manager</h1>
          </div>
        </vx-card>
        <vx-card class="p-6 cursor-pointer text-white"
                 :style="`background-image: linear-gradient(118deg, rgba(var(--vs-primary), 0.4), rgba(var(--vs-primary), .2)), url(${cardBgImgURL})`"
                 @click="$router.push('/a/labs/accounts/list')">
          <div class="flex items-center justify-center">
            <feather-icon icon="UsersIcon" svgClasses="h-16 w-16"/>
          </div>
          <div class="flex items-center justify-center">
            <h1 class="text-center mt-4">Account<br>Manager</h1>
          </div>
        </vx-card>
        <vx-card class="p-6 cursor-pointer text-white"
                 :style="`background-image: linear-gradient(118deg, rgba(var(--vs-danger), 0.4), rgba(var(--vs-danger), .2)), url(${cardBgImgURL})`"
                 @click="$router.push('/a/labs/pools/list')">
          <div class="flex items-center justify-center">
            <feather-icon icon="DatabaseIcon" svgClasses="h-16 w-16"/>
          </div>
          <div class="flex items-center justify-center">
            <h1 class="text-center mt-4">Pool<br>Manager</h1>
          </div>
        </vx-card>
      </div>
    </div>
    <!--- COURSE ACTION BAR END --->

  </div>
</template>

<!--suppress ES6ShorthandObjectProperty -->
<script>

export default {
  data () {
    return {
      cardBgImgURL: 'https://media.discordapp.net/attachments/733851758211629347/954057924630700132/BG2.png?width=1352&height=676'
    }
  },
  methods: {

  }
}
</script>
